module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_3.c37e13c6.png";